export const SITE_DOMAIN = 'mayarschools.edu.jo'
export const SITE_URL = import.meta.env.VITE_SITE_URL || `https://${SITE_DOMAIN}`

export const EXTERNAL_LINKS = {
  eSchool: 'https://lms.mayarschools.edu.jo/',
  jobs: 'https://jobs.mayarschools.edu.jo/',
}

export const CONTACT_SUBJECT_KEYS = ['inquiry', 'complaint', 'visit_appointment', 'other']

export const CONTACT_BRANCH_KEYS = ['MisTlaAlAli', 'MisKhalda']

export const CONTACT_BRANCH_BY_PAGE = {
  MisTlaAlAli: 'MisTlaAlAli',
  MisKhalda: 'MisKhalda',
}

export function getContactBranchFromPathname(pathname = '') {
  const match = pathname.match(/^\/pages\/(MisTlaAlAli|MisKhalda)\/?$/)
  return match ? CONTACT_BRANCH_BY_PAGE[match[1]] : ''
}

export function resolveContactBranch(searchParams) {
  const directBranch = searchParams.get('branch') || searchParams.get('campus')
  if (CONTACT_BRANCH_KEYS.includes(directBranch)) {
    return directBranch
  }

  const fromPage = searchParams.get('from')
  if (CONTACT_BRANCH_BY_PAGE[fromPage]) {
    return CONTACT_BRANCH_BY_PAGE[fromPage]
  }

  return ''
}

export function buildContactUrl({ subject, branch, event, from } = {}) {
  const params = new URLSearchParams()

  if (subject && CONTACT_SUBJECT_KEYS.includes(subject)) {
    params.set('subject', subject)
  }

  const resolvedBranch =
    branch && CONTACT_BRANCH_KEYS.includes(branch)
      ? branch
      : from && CONTACT_BRANCH_BY_PAGE[from]
        ? CONTACT_BRANCH_BY_PAGE[from]
        : ''

  if (resolvedBranch) {
    params.set('branch', resolvedBranch)
  }

  if (event) {
    params.set('event', event)
  }

  const query = params.toString()
  return query ? `/contact?${query}` : '/contact'
}

export const DEFAULT_CONTACT = {
  school_name: 'Mayar International Schools',
  school_name_ar: 'مدارس ميار الدولية',
  phone: '+962-6-5670002',
  fax: '+962-6-5671941',
  mobile: '+962-79-8866115',
  email: 'info@mayar-schools.com',
  american_program_counselor_email: 'int.programsassistant@mayar-schools.com',
  international_program_director_email: 'int.director@mayar-schools.com',
  sadeen_group: 'Member of Sadeen Group',
  sadeen_group_ar: 'عضو في مجموعة صدين',
  address_en: 'Tla Al-Ali & Khalda, Amman, Jordan',
  address_ar: 'تلاع العلي وخلدا، عمان، الأردن',
  google_maps_url:
    'https://www.google.com/maps?cid=597657491367773538&hl=en-US',
  google_maps_embed_url:
    'https://www.google.com/maps?cid=597657491367773538&hl=en-US&output=embed',
}
